import React, { Component } from 'react'
import { connect } from 'react-redux'
import styled, { css, injectGlobal } from 'styled-components'
import { rgba } from 'polished'

import { updateSettings } from '../../settings'
import { fetchResources, getResources } from './redux'

import { Attachment } from '../../components'
import { media } from '../../styles/utils';
import { green, greenSecondary } from '../../styles/colors';
import { hoverState, padding } from '../../styles/global';

class Resources extends Component {

    state = {

    }

    static fetchData(store, match) {
        return store.dispatch(fetchResources()); 
    }

    componentDidMount = () => {
        const { updateSettings } = this.props;
        
        this.props.fetchResources()

        updateSettings({
            pageTitle: 'Resources'
        })
    }

    formatBytes = (bytes,decimals) => {
        if(bytes == 0) return '0 Bytes';
        var k = 1024,
            dm = decimals || 2,
            sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'],
            i = Math.floor(Math.log(bytes) / Math.log(k));
        return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
    }

    renderResources = () => {
        const { resources } = this.props;

        //console.log(resources)
        if (resources.data) {
            return resources.data.map((group, i) => {
                
                if (group.display) {
                    return (
                        <ResourceGroup
                            key={i}
                        >
                            <Title>{group.section_title}</Title>  
                    
                            <Grid>
                                {group.items && group.items.map((item, i) => {
                                    if (item.display) {
                                        let title = item.file.title;
                                        if (item.title_override!='') title = item.title_override;

                                        return (
                                            <Attachment
                                                label={title}
                                                size={this.formatBytes(item.file.filesize)}
                                                url={item.file.url}  
                                                key={i}       
                                                border={'black'}        
                                                file={item.file}               
                                            />
                                        )
                                    }
                                })}
                            </Grid>
                        </ResourceGroup>
                    )
                }
            })
        }
    }
      
    render() {
        return (
            <Container>
                {this.renderResources()}             
            </Container>
        )
    }
}

const Container = styled.div`
    overflow: hidden;
    flex: 1;
    width: 100%;
    height: calc(100vh - 65px); 
    overflow-y: scroll;
    box-sizing: border-box;
`

const Title = styled.div``

const ResourceGroup = styled.div`
    display: flex;
    ${padding}
    padding-top: 25px;
    padding-bottom: 80px;
    flex: 1 0 auto;

    &:first-child {
        padding-top: 12px;
    }
    
    &:not(:last-child) {
        border-bottom: 1px solid black;
    }

    ${Title} {
        flex: 0 1 240px;
        font-size: 24px;
    }

    ${media.phone`
        flex: 0 1 auto;
        flex-direction: column;
        padding-bottom: 24px;

        ${Title} {
            flex: 0 1 auto;
            margin-bottom: 4px;
            font-size: 22px !important;
        }
    `}
`

const Grid = styled.div`
    display: flex;
    flex-flow: row wrap;
    width: calc(100% + 17px);
    padding: 13px;
    padding-top: 8px;
    box-sizing: border-box;
    flex: 1;
    max-width: 1280px;

    > * {
        display: flex;
        flex-direction: column;
        flex: 0 1;
        flex-basis: calc(33.3% - 17px);
        margin-right: 17px;
        margin-bottom: 30px;

        ${media.phone`
            flex-basis: calc(50% - 17px);
        `}
    }

    ${media.phone`
        padding-left: 0;
        padding-bottom: 0;
        flex-direction: column;

        > * {
            flex: 0;
            margin-bottom: 8px;
            margin-right: 0;
        }
    `}
`

const mapDispatchToProps = dispatch => ({
    fetchResources() {
        dispatch(fetchResources())
    },
    updateSettings(setting) {
        dispatch(updateSettings(setting))
    },
})

const mapStateToProps = (state, props) => ({
    resources: getResources(state)
})


export default connect(mapStateToProps, mapDispatchToProps)(Resources);



// WEBPACK FOOTER //
// ./client/modules/Resources/Resources.js